import {
    ChangeDetectorRef,
    Component, EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    Renderer2,
    TemplateRef,
    ViewChild,
    ViewChildren,
} from "@angular/core";
import { Compbaser } from "../../../components/compbaser";
import {
    FileObj,
    ICRUDOverrides,
    ICRUDRecord,
    IResource,
    IResourceUpload,
    IUser,
    IZivud,
    UploadStatus,
} from "../../../interfaces";
import { AppService, LocalStoreService, StoreSelectorsService } from "../../../services";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
    actionAddResources,
    actionLoadDynawebsEquipment,
    actionLoadDynawebsEquipmentReply,
    actionSaveDynawebsEquipment,
    actionSaveDynawebsEquipmentSuccess,
    actionSaveFailedDynawebsEquipment,
} from "../../../store/actions/user.actions";
import {
    copyTextClipboard,
    EQUIP_ACCESS,
    formatBytes,
    isHostLocal,
    isNullOrUndefOrEmpty,
    LIMIT_UPLOADS_COUNT,
    restrictSingleQuote,
    SUPPORTED_FILE_TYPES,
} from "../../../common";
import { TranslocoService } from "@ngneat/transloco";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Lib } from "libs/Lib";
import { catchError, map, take, timeout } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { isNotNullOrUndefined } from "codelyzer/util/isNotNullOrUndefined";
import { ofType } from "@ngrx/effects";
import { ActionsSubject } from "@ngrx/store";
import { HttpClient } from "@angular/common/http";
import * as _ from "lodash";
import * as Papa from "papaparse";
import { MatInput } from "@angular/material/input";
import { faGun, faHandcuffs, faPersonRifle, faWalkieTalkie } from "@fortawesome/free-solid-svg-icons";

/**
 * link to edit vehicles:
 * https://docs.google.com/spreadsheets/d/15_ImnRy-a-zOzen78AQ-2nlL72ew-g2dali2jPFYzek/edit?gid=0#gid=0
 */

enum EnumViewMode {
    NOT_LOGGED_IN,
    CHECKING_1,
    CHECKING_2,
    COMPLETED,
}

interface TableData {
    name: string;
    value: string;
}

interface IFileInfo {
    fileId: string;
    fileSize: number;
    progress: number;
}

@Component({
    selector: "app-equipped",
    templateUrl: "./equipped.component.html",
    styleUrls: ["./equipped.component.scss"]
})
export class EquippedComponent extends Compbaser implements OnInit {
    @Input() category = "";
    @ViewChild("uploadModal", { read: TemplateRef }) uploadModal: TemplateRef<any>;
    @ViewChild("problemSaving", { read: TemplateRef }) problemSaving: TemplateRef<any>;
    @ViewChildren("inputBox") inputBoxes!: QueryList<MatInput>;
    @ViewChildren("inputBox1") inputBoxes1!: QueryList<MatInput>;
    @ViewChildren("inputBox2") inputBoxes2!: QueryList<MatInput>;
    @ViewChildren("inputBox3") inputBoxes3!: QueryList<MatInput>;
    @Output() form2Submitted = new EventEmitter<any>();

    debugMode = false;

    private readonly IMAGE_MAX_SIZE_MB = 1.5;
    private readonly IMAGE_COMPRESS: boolean = true;

    // Low bandwidth mode settings
    useLowBandwidthMode = true;
    private readonly LOW_BANDWIDTH_MAX_SIZE_MB = 0.3;
    private readonly LOW_BANDWIDTH_MAX_DIMENSION = 1024;

    // Tracks how many images are in the middle of being compressed:
    imagesBusyCount = 0;

    // Controls whether the button 'לסיכום' is disabled:
    lesikumDisabled = true;

    viewMode: EnumViewMode = EnumViewMode.NOT_LOGGED_IN;
    startCheckDisabled = true;
    wizardDisabled1 = true;
    wizardDisabled2 = true;
    imageData: string[] = [];
    userName = "";
    officerId = "";
    email = "";
    selectedCaptain: any;
    selectedVehicle: any;
    selectedCodeCall: any;
    dateNow: string;
    form: FormGroup;
    filesUploaded = [];
    uploadModalRef: MatDialogRef<any>;
    m_user: IUser;
    lastZivud: IZivud;
    uploading = false;
    uploadPercentage = 0;
    totalFileSize = 0;
    formattedTotalSize = "0 Byte";
    formattedUploadingSize = "0 Byte";
    selectedFiles: Array<FileObj> = [];
    copyFileObjects: Array<IFileInfo> = [];
    version = "16.06";
    studioId = "";
    kitatKonenut = false;
    maxNaznaz = _.range(0, 7).map(String);
    sheetUrl = `https://docs.google.com/spreadsheets/d/15_ImnRy-a-zOzen78AQ-2nlL72ew-g2dali2jPFYzek/export?format=csv`;
    emailSendTo = [{ name: "יוחאי", email: "yohayl1707@gmail.com" }];
    displayedColumns: string[] = ["value", "name"];
    equipmentSummary: TableData[] = [];
    missingEquipmentSummary = [];
    isDisabledLogin = false;
    inputControls = Array(6).fill(null);
    inputValues = ["", "", "", "", "", ""];
    inputValuesReady = false;

    // Input controls for the 3 verification containers
    inputControls1 = Array(6).fill(null);
    inputValues1 = ["", "", "", "", "", ""];
    inputControls2 = Array(6).fill(null);
    inputValues2 = ["", "", "", "", "", ""];
    inputControls3 = Array(6).fill(null);
    inputValues3 = ["", "", "", "", "", ""];
    inputVerifyComplete = false;
    inSerialDev = false; // Flag to enable/disable serial number verification (Vest 1, Vest 2, Road Cone)

    // Serial number validation
    serialVerifications = {
        bulletProofVest: ['100100', '100101', '100102'],
        roadCones: ['200100', '200101', '200102']
    };
    serialValid1: boolean | null = null;
    serialValid2: boolean | null = null;
    serialValid3: boolean | null = null;

    leftCheckboxes: string[] = [];
    rightCheckboxes: string[] = [];
    faGun = faGun;
    faPersonRifle = faPersonRifle;
    faHandcuffs = faHandcuffs;
    faWalkieTalkie = faWalkieTalkie;
    secondTabForm: FormGroup;
    numberOptions: number[] = Array.from({ length: 100 }, (_, i) => i);
    imageDataStep1: string[] = [];
    selectedFilesStep1: FileObj[] = [];
    step1PhotosDisabled = true;
    imageDataStep2: string[] = [];
    selectedFilesStep2: FileObj[] = [];
    step2PhotosDisabled = true;
    tikPizorSelected = false;
    tikiyotSelected = false;

    debouncedProblemSavingDialog: (err: string) => void;
    protected readonly EnumViewMode = EnumViewMode;

    vehicles = [
        { id: "25-390", zivud: true },
        { id: "24-349", zivud: true },
        { id: "25-288", zivud: true },
        { id: "25-168", zivud: true },
        { id: "25-916", zivud: true },
        { id: "25-848", zivud: true },
        { id: "25-944", zivud: true },
        { id: "25-845", zivud: true },
        { id: "11-743", zivud: true },
        { id: "21-856", zivud: true },
        { id: "19-319", zivud: true },
        { id: "30-042", zivud: true },
        { id: "486", zivud: true },
        { id: "14-914", zivud: true },
        { id: "17-568", zivud: true },
    ];


    // vehicles = [
    //     {id: '25-168', zivud: true},
    //     {id: '25-288', zivud: true},
    //     {id: '25-001', zivud: true},
    //     {id: '25-845', zivud: true},
    //     {id: '25-848', zivud: true},
    //     {id: '25-916', zivud: true},
    //     {id: '25-944', zivud: true},
    //     {id: '11-743', zivud: true},
    //     {id: '24-349', zivud: true},
    //     {id: '19-103', zivud: false},
    //     {id: '11-403', zivud: false},
    //     {id: '14-914', zivud: false},
    //     {id: '466-28-802', zivud: false},
    //     {id: '17-568', zivud: false}
    // ];

    levIds: string[] = [...Array.from({ length: 200 }, (_, i) => (400 + i).toString() + " לב "), "000"];
    avivIds: string[] = [...Array.from({ length: 100 }, (_, i) => (300 + i).toString() + " אביב ")];
    callIds: string[];

    overrideCredentials: ICRUDOverrides = {
        user: "zivudlev@gmail.com",
        password: "policelev@",
        webApiBaseUrl: "https://ida.signage.me",
        businessId: "627453",
    };

    // Google Drive configuration
    private readonly GOOGLE_DRIVE_TOKEN = "e35d71ad-0dda-4247-bfb9-c3d6a5e0dc1b";
    private readonly GOOGLE_DRIVE_FOLDER_ID = "1okXnY4asAIT0UXR7zvlJdeINBckiB9bl"; // folder name: zivud
    private readonly UPLOAD_BACKEND_URL = "https://secure.digitalsignage.com";
    private readonly MAX_FILE_SIZE_MB = 75; // Maximum file size in MB
    private readonly MAX_FILES_COUNT = 20; // Maximum number of files per upload

    inv = [
        // -------------------------------------------------------
        // (A) OTHER (not validated by wizard1 or wizard2)
        // -------------------------------------------------------
        { name: "date", place: "", maxStock: null, value: this.getDate(), addToReport: 0, equipmentSummary: 0 },
        { name: "הערות", place: "wizard2", value: 0, addToReport: 0, equipmentSummary: 0 },

        // -------------------------------------------------------
        // (B) WIZARD1 (place: 'wizard1')
        // -------------------------------------------------------
        // Some items also have checkPage1: 1 for your step-1 logic
        {
            name: "תיקיות",
            place: "wizard1",
            maxStock: 1,
            value: false,
            checkPage1: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },

        {
            name: "תיק_מחסומים",
            place: "wizard1",
            maxStock: 1,
            value: "0",
            checkPage1: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "תיק_סיור",
            place: "wizard1",
            maxStock: 1,
            value: "0",
            checkPage1: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "תיק_שטח",
            place: "wizard1",
            maxStock: 1,
            value: "0",
            checkPage1: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "אפוד_קרמי",
            place: "wizard1",
            maxStock: 2,
            value: "0",
            checkPage1: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "אפוד_מגן",
            place: "wizard1",
            maxStock: 2,
            value: "0",
            checkPage1: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        { name: "קסדה", place: "wizard1", maxStock: 2, value: "0", checkPage1: 1, addToReport: 1, equipmentSummary: 0 },
        { name: "אלה", place: "wizard1", maxStock: 2, value: "0", checkPage1: 1, addToReport: 1, equipmentSummary: 0 },
        {
            name: "תיק_פיזור",
            place: "wizard1",
            maxStock: 1,
            value: false,
            checkPage1: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מספר_נשק",
            place: "wizard1",
            maxStock: 1,
            checkLength: 2,
            checkPage1: 1,
            addToReport: 0,
            equipmentSummary: 1,
        },
        { name: "מספר_נשק2", place: "wizard1", maxStock: 1, addToReport: 0, equipmentSummary: 1 },
        { name: "אזיק_רגליים", place: "wizard1", maxStock: 1, addToReport: 0, equipmentSummary: 1 },
        { name: "מספר_טייזר", place: "wizard1", maxStock: 1, addToReport: 0, equipmentSummary: 1 },
        {
            name: "מספר_טאבלט",
            place: "wizard1",
            maxStock: 1,
            checkLength: 2,
            checkPage1: 1,
            addToReport: 0,
            equipmentSummary: 1,
        },
        {
            name: "מספר_קשר1",
            place: "wizard1",
            maxStock: 1,
            checkLength: 2,
            checkPage1: 1,
            addToReport: 0,
            equipmentSummary: 1,
        },
        { name: "מספר_קשר2", place: "wizard1", maxStock: 1, addToReport: 0, equipmentSummary: 1 },

        // -------------------------------------------------------
        // (C) WIZARD2 (place: 'wizard2')
        // -------------------------------------------------------
        // Marked with checkPage2: 1 => validated in step 2
        { name: "סדר", place: "wizard2", value: "?", checkPage2: 1, addToReport: 0, equipmentSummary: 0 },
        {
            name: "קילומטראז",
            place: "wizard2",
            value: 0,
            checkPage2: 1,
            checkLength: 3,
            addToReport: 0,
            equipmentSummary: 0,
        },
        {
            name: "גשר_תאורה_מהבהב",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מחסום_סטינגר_דוקרנים",
            place: "wizard2",
            maxStock: 2,
            value: "0",
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        // {name: 'טרפזים', place: 'wizard2', maxStock: 8, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {
            name: "אוהל_מחסום",
            place: "wizard2",
            maxStock: 2,
            value: "0",
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "בדיקת_אומים",
            place: "wizard2",
            maxStock: 20,
            value: "0",
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מגפון",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מתודלקת",
            place: "wizard2",
            maxStock: 100,
            value: "0%",
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        { name: "חומס", place: "wizard2", maxStock: 2, value: "0", checkPage2: 1, addToReport: 1, equipmentSummary: 0 },
        // {name: 'נצנצים_קימים', place: 'wizard2', maxStock: 6, value: '0', checkPage2: 1, addToReport: 1, equipmentSummary: 0},
        {
            name: "נצנצים_טעונים",
            place: "wizard2",
            maxStock: 6,
            value: "0",
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        { name: "ססל", place: "wizard2", maxStock: 5, value: "0", checkPage2: 1, addToReport: 1, equipmentSummary: 0 },
        {
            name: "יריעה_לגופה",
            place: "wizard2",
            maxStock: 2,
            value: "0",
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "חליפת_סערה",
            place: "wizard2",
            maxStock: 2,
            value: "0",
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },

        // Wizard2 left group => multiCheckLeft:1
        {
            name: "ערכת_עזרה_ראשונה",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckLeft: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מטף_כיבוי_לרכב",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckLeft: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מגבה_לרכב_ידית_מפתח",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckLeft: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "גלגל_ספייר",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckLeft: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "אפודה_זוהרת",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckLeft: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "משולש_אזהרה",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckLeft: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מערכת_כריזה",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckLeft: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מערכת_קשר",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckLeft: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },

        // Wizard2 right group => multiCheckRight:1
        {
            name: "עמדת_עריסה",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckRight: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מכשיר_נייד_מיקרופון",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckRight: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מצלמת_רוורס",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckRight: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מדפסת_נייר",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckRight: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מגבר_צופר_רמקול_מיקרופון",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckRight: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "adblue",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckRight: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "נורת_בדוק_מנוע",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckRight: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "נורת_בדוק_מצבר",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckRight: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מערכת_כריזה",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckLeft: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },
        {
            name: "מערכת_קשר",
            place: "wizard2",
            maxStock: 1,
            value: "0",
            multiCheckLeft: 1,
            checkPage2: 1,
            addToReport: 1,
            equipmentSummary: 0,
        },

        // 'טיהור_תא_עצורים' also in wizard2 checks
        { name: "טיהור_תא_עצורים", place: "wizard2", maxStock: 1, value: "", checkPage2: 1, addToReport: 0 },
    ];

    constructor(
        private fb: FormBuilder,
        private fb2: FormBuilder,
        private renderer: Renderer2,
        private http: HttpClient,
        private appService: AppService,
        private actionsSubj: ActionsSubject,
        private toastr: ToastrService,
        private translocoService: TranslocoService,
        private cd: ChangeDetectorRef,
        private localStoreService: LocalStoreService,
        public storeSelector: StoreSelectorsService,
        dialog: MatDialog,
    ) {
        super(dialog);
        this.setMe("equipped-component");
        console.log("equipment running version: " + this.version);
        this.callIds = [...this.levIds, ...this.avivIds];
        this.appService.checkAppVersion().then((v) => {
            console.log("equipment checked version " + v);
        });

        this.debouncedProblemSavingDialog = _.debounce((err: string) => {
            this.problemSavingDialog(err);
        }, 1500);

        /*** Toggle debug if local as well as codeCall = 000 for full test mode ***/
        if (isHostLocal()) {
            this.setDebugging();
        }

        // Load Google Sheet data
        this.fetchSheetData().subscribe({
            next: (data) => {
                // Attempt to parse email + vehicles from Google Sheet
                const sheetData = data;
                const pattern = /^\s*(?:([A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,})\s+(.*)|(.+)\s+([A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}))\s*$/;
                try {
                    this.emailSendTo = [];
                    if (Array.isArray(sheetData) && sheetData.length > 5) {
                        sheetData.forEach((item) => {
                            if (item?.email) {
                                const match = item.email.match(pattern);
                                if (match) {
                                    let email = match[1] || match[4];
                                    let name = match[2] || match[3];
                                    email = email.trim();
                                    name = name.trim();
                                    this.emailSendTo.push({ name, email });
                                }
                            }
                            if (item?.vehicles && item?.vehicles.length > 4) {
                                this.vehicles.push({
                                    id: item.vehicles,
                                    zivud: item.vizud?.toLowerCase(),
                                });
                            }
                        });
                    }
                } catch (e) {
                    this.emailSendTo = [{ name: "יוחאי", email: "yohayl1707@gmail.com" }];
                    console.error("problem building google sheet list");
                }
                this.vehicles = _.uniqBy(this.vehicles, "id");
            },
            error: (err) => console.error("Error fetching sheet data:", err),
        });

        // Listen for lastZivud data from store
        this.cod(
            this.actionsSubj.pipe(ofType(actionLoadDynawebsEquipmentReply))
                .subscribe((reply) => {
                    if (isNotNullOrUndefined(reply?.payload?.vehicleId)) {
                        this.lastZivud = reply.payload;
                    }
                }),
        );

        const date = new Date();
        this.dateNow = date.toLocaleString("he-IL", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        });

        this.createForm();

        // Re-hydrate from local storage
        this.userName = isNullOrUndefOrEmpty(
            this.localStoreService.getStorageValConfig("equipmentUser"),
        )
            ? ""
            : this.localStoreService.getStorageValConfig("equipmentUser");
        this.officerId = isNullOrUndefOrEmpty(
            this.localStoreService.getStorageValConfig("equipmentId"),
        )
            ? ""
            : this.localStoreService.getStorageValConfig("equipmentId");

        const acc = isNullOrUndefOrEmpty(
            this.localStoreService.getStorageValConfig("equipmentAccess"),
        )
            ? ""
            : this.localStoreService.getStorageValConfig("equipmentAccess");
        if (acc?.length > 4) {
            this.onLoginCheck(acc);
        }

        if (this.debugMode) {
            this.setDebugging();
        }
    }


    ngOnInit() {
        // Apply light theme without saving to storage
        // Theme "1" = light, directly manipulate DOM
        document.body.classList.remove("app-theme-dark", "app-theme-light", "app-theme-gradient");
        document.body.classList.add("app-theme-light");

        // Also apply with a delay to ensure it overrides any app initialization
        setTimeout(() => {
            this.localStoreService.setStorageValConfig('theme', '1');
        }, 100);
        this.renderer.setAttribute(document.body, "translate", "no");
        this.studioId = this.localStoreService.getStorageConfig().studioId;

        this.leftCheckboxes = this.inv
            .filter(item => item.multiCheckLeft === 1)
            .map(item => item.name);

        // Example: create rightCheckboxes
        this.rightCheckboxes = this.inv
            .filter(item => item.multiCheckRight === 1)
            .map(item => item.name);

        this.secondTabForm = this.fb2.group({
            drop1: [null],
            drop2: [null],
            drop3: [null],
            drop4: [null],
            comments: [null],
        });

        // Watch for changes to תיקיות
        this.form.get("תיקיות")?.valueChanges.subscribe(value => {
            console.log("תיקיות value changed:", value, typeof value); // Debug log

            // Handle both boolean and string values
            this.tikiyotSelected = value === true || value === "true" || value === "1";

            console.log("tikiyotSelected is now:", this.tikiyotSelected); // Debug log

            if (this.tikiyotSelected) {
                // Set all 3 dropdowns to value "1" (max value)
                this.form.get("תיק_מחסומים")?.setValue("1");
                this.form.get("תיק_סיור")?.setValue("1");
                this.form.get("תיק_שטח")?.setValue("1");

                // Mark them as touched for validation
                this.form.get("תיק_מחסומים")?.markAsTouched();
                this.form.get("תיק_סיור")?.markAsTouched();
                this.form.get("תיק_שטח")?.markAsTouched();

                console.log("Set all 3 bag dropdowns to 1"); // Debug log
            } else {
                // Optional: Reset values when unchecked
                this.form.get("תיק_מחסומים")?.setValue("0");
                this.form.get("תיק_סיור")?.setValue("0");
                this.form.get("תיק_שטח")?.setValue("0");

                console.log("Reset all 3 bag dropdowns to 0"); // Debug log
            }

            // Trigger change detection
            this.cd.detectChanges();
        });

        // Watch for changes to תיק_פיזור
        this.form.get("תיק_פיזור")?.valueChanges.subscribe(value => {
            console.log("תיק_פיזור value changed:", value, typeof value); // Debug log

            // Handle both boolean and string values
            this.tikPizorSelected = value === true || value === "true" || value === "1";

            console.log("tikPizorSelected is now:", this.tikPizorSelected); // Debug log

            if (this.tikPizorSelected) {
                // Set all 4 dropdowns to value "2" (max value)
                this.form.get("אלה")?.setValue("2");
                this.form.get("קסדה")?.setValue("2");
                this.form.get("אפוד_מגן")?.setValue("2");
                this.form.get("אפוד_קרמי")?.setValue("2");

                // Mark them as touched for validation
                this.form.get("אלה")?.markAsTouched();
                this.form.get("קסדה")?.markAsTouched();
                this.form.get("אפוד_מגן")?.markAsTouched();
                this.form.get("אפוד_קרמי")?.markAsTouched();

                console.log("Set all 4 dropdowns to 2"); // Debug log
            } else {
                // Optional: Reset values when unchecked
                this.form.get("אלה")?.setValue("0");
                this.form.get("קסדה")?.setValue("0");
                this.form.get("אפוד_מגן")?.setValue("0");
                this.form.get("אפוד_קרמי")?.setValue("0");

                console.log("Reset all 4 dropdowns to 0"); // Debug log
            }

            // Trigger change detection
            this.cd.detectChanges();
        });
    }

    onSecondTabSubmit() {
        const selections = this.secondTabForm.value;
        console.log("Second tab form submitted:", selections);
        this.form2Submitted.emit(selections);
    }

    changeMaxNaznaz(e) {
        this.maxNaznaz = _.range(0, Number(e.value) + 1).map(String);
    }

    createForm() {
        const formGroup = {};
        this.inv.forEach(item => {
            formGroup[item.name] = [item.value || "", this.getValidators(item)];
        });
        this.form = this.fb.group(formGroup);
    }

    private getValidators(item): Validators[] {
        const validators = [];
        if (item.maxStock !== undefined && item.maxStock !== null) {
            validators.push(Validators.max(item.maxStock));
        }
        return validators;
    }

    onSelectedCaptain() {
        // Placeholder if needed
    }

    onSelectedVehicle() {
        if (!this.selectedVehicle) return;
        // If a certain vehicle is not "zivud," skip wizard requirements
        if (this.selectedVehicle.zivud === false) {
            this.wizardDisabled1 = false;
            this.wizardDisabled2 = false;
        }
    }

    checkString(value, len): boolean {
        if (value === null) return false;
        const v = String(value);
        return typeof v === "string" && v.length > len;
    }

    private updateLesikumButtonDisabledState(): void {
        // Disable if there are NO files or if some are still compressing
        this.lesikumDisabled = !(this.selectedFiles.length > 0 && this.imagesBusyCount === 0);
    }

    isDebugModeCodeCall() {
        if (this.selectedCodeCall === "000") {
            this.setDebugging();
            console.log(`selection ${this.debugMode} / ${this.version}`);
        }
    }

    checkStartCheckReady() {
        if (!isNotNullOrUndefined(this.selectedCaptain)) return false;
        if (!isNotNullOrUndefined(this.selectedVehicle)) return false;
        if (
            this.checkString(this.selectedVehicle.id, 4) &&
            this.checkString(this.officerId, 4) &&
            !isNullOrUndefOrEmpty(this.selectedCodeCall) &&
            this.checkString(this.userName, 1)
        ) {
            this.startCheckDisabled = false;
        } else {
            this.startCheckDisabled = true;
        }
    }

    private calcTotalSize() {
        this.totalFileSize = this.copyFileObjects.reduce((size, fileObj) => {
            return size + fileObj.fileSize;
        }, 0);
        this.formattedTotalSize = formatBytes(this.totalFileSize, 2);
    }

    private showUploadingWaitDialog() {
        this.copyFileObjects = this.selectedFiles.map((fileObj) => ({
            fileId: fileObj.fileId,
            fileSize: fileObj.fileSize,
            progress: fileObj.progress,
        }));
        this.calcTotalSize();
        this.uploadPercentage = 0;
        this.formattedUploadingSize = "0 Byte";

        this.uploadModalRef = this.dialog.open(this.uploadModal, {
            height: "520px",
            width: "500px",
            panelClass: "transparentDialog",
            data: {},
        });
    }

    private isMobileDevice(): boolean {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    private uploadSelectedFiles() {
        const validUploadFiles = this.selectedFiles.filter((fileObj) =>
            fileObj.uploadStatus === UploadStatus.READY || fileObj.uploadStatus === UploadStatus.FAILED,
        );

        // Upload all files to Google Drive at once
        this.uploadToGoogleDrive(validUploadFiles);
    }

    private uploadToGoogleDrive(fileObjects: FileObj[]) {
        // Validate inputs
        if (!fileObjects || fileObjects.length === 0) {
            this.toastr.error("No files to upload");
            return;
        }

        // Check configuration
        if (!this.GOOGLE_DRIVE_TOKEN || !this.UPLOAD_BACKEND_URL) {
            this.toastr.error("Google Drive upload not configured. Please contact administrator.");
            return;
        }

        // Validate file count
        if (fileObjects.length > this.MAX_FILES_COUNT) {
            this.toastr.error(`Too many files selected. Maximum is ${this.MAX_FILES_COUNT} files per upload.`);
            return;
        }

        // Validate file sizes
        const oversizedFiles = fileObjects.filter(file =>
            file.fileSize && file.fileSize > this.MAX_FILE_SIZE_MB * 1024 * 1024,
        );
        if (oversizedFiles.length > 0) {
            this.toastr.error(`Some files are too large. Maximum size is ${this.MAX_FILE_SIZE_MB}MB per file.`);
            return;
        }

        // Validate file types (basic client-side check)
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif", "video/mp4", "video/quicktime"];
        const invalidFiles = fileObjects.filter(file =>
            file.file && !allowedTypes.includes(file.file.type.toLowerCase()),
        );
        if (invalidFiles.length > 0) {
            this.toastr.error("Some files have invalid formats. Only images (JPG, PNG, GIF) and videos (MP4, MOV) are allowed.");
            return;
        }

        // Set up progress tracking objects before starting upload
        this.copyFileObjects = fileObjects.map((fileObj) => ({
            fileId: fileObj.fileId || `temp_${Date.now()}_${Math.random()}`,
            fileSize: fileObj.fileSize || 0,
            progress: 0,
        }));
        this.calcTotalSize();
        this.uploadPercentage = 0;
        this.formattedUploadingSize = "0 Byte";

        // Show the upload dialog with error handling
        try {
            this.uploadModalRef = this.dialog.open(this.uploadModal, {
                height: "520px",
                width: "500px",
                panelClass: "transparentDialog",
                data: {},
                disableClose: true, // Prevent accidental closure during upload
            });
        } catch (error) {
            console.error("Failed to open upload dialog:", error);
            this.toastr.error("Failed to show upload progress dialog");
            return;
        }

        const formData = new FormData();

        // Add all files to FormData
        fileObjects.forEach((fileObj) => {
            formData.append("files", fileObj.file);
            fileObj.uploadStatus = UploadStatus.INPROGRESS;
            fileObj.progress = 0;
        });

        // Construct upload URL
        const uploadUrl = `${this.UPLOAD_BACKEND_URL}/policeUpload/${this.GOOGLE_DRIVE_TOKEN}/${this.GOOGLE_DRIVE_FOLDER_ID || ""}`;

        // Use XMLHttpRequest to track upload progress
        const xhr = new XMLHttpRequest();
        const isMobile = this.isMobileDevice();
        let mobileProgressInterval: any;

        // Set timeout to prevent hanging uploads
        xhr.timeout = 10 * 60 * 1000; // 10 minutes timeout

        // Mobile devices often don't report progress events properly
        if (isMobile) {
            // Show simulated progress for mobile devices
            this.toastr.info("Mobile upload detected - progress may be estimated");
            let simulatedProgress = 0;
            let uploadStartTime = Date.now();
            let hasReachedFinalStage = false;

            mobileProgressInterval = setInterval(() => {
                const elapsedTime = Date.now() - uploadStartTime;
                let maxSimulatedProgress = 85; // Start with higher initial max
                let progressIncrement = Math.random() * 3 + 1; // Faster initial progress: 1-4% per interval

                // More aggressive progression to reach higher percentages
                if (elapsedTime > 20000) { // After 20 seconds, allow up to 98%
                    maxSimulatedProgress = 98;
                    if (!hasReachedFinalStage) {
                        hasReachedFinalStage = true;
                        progressIncrement = 3; // Jump to show we're in final stage
                    } else {
                        progressIncrement = Math.random() * 0.3 + 0.1; // Very slow final 2%
                    }
                } else if (elapsedTime > 12000) { // After 12 seconds, allow up to 95%
                    maxSimulatedProgress = 95;
                    progressIncrement = Math.random() * 1 + 0.5; // Slower progress in final stages
                } else if (elapsedTime > 6000) { // After 6 seconds, allow up to 90%
                    maxSimulatedProgress = 90;
                    progressIncrement = Math.random() * 2 + 1;
                } else if (elapsedTime > 2000) { // After 2 seconds, allow up to 87%
                    maxSimulatedProgress = 87;
                    progressIncrement = Math.random() * 2.5 + 1.5;
                }

                if (simulatedProgress < maxSimulatedProgress) {
                    simulatedProgress = Math.min(simulatedProgress + progressIncrement, maxSimulatedProgress);

                    fileObjects.forEach((fileObj, index) => {
                        fileObj.progress = Math.round(simulatedProgress);
                        if (this.copyFileObjects[index]) {
                            this.copyFileObjects[index].progress = Math.round(simulatedProgress);
                        }
                    });

                    this.calcUploadingPercentage();
                    this.cd.detectChanges();
                }
            }, 600); // Faster updates for smoother progression
        }

        xhr.upload.addEventListener("progress", (event) => {
            if (event.lengthComputable && !isMobile) {
                // Only use real progress on desktop browsers
                const percentComplete = Math.round((event.loaded / event.total) * 100);
                // Update progress for all files
                fileObjects.forEach((fileObj, index) => {
                    fileObj.progress = percentComplete;
                    // Update the copyFileObjects as well for progress calculation
                    if (this.copyFileObjects[index]) {
                        this.copyFileObjects[index].progress = percentComplete;
                    }
                });
                this.calcUploadingPercentage();
                this.cd.detectChanges();
            }
        });

        xhr.addEventListener("timeout", () => {
            // Clear mobile progress simulation
            if (mobileProgressInterval) {
                clearInterval(mobileProgressInterval);
            }

            fileObjects.forEach((fileObj) => {
                fileObj.progress = 0;
                fileObj.uploadStatus = UploadStatus.FAILED;
            });
            this.toastr.error("Upload timed out. Please check your connection and try again.");
            this.calcUploadingPercentage();
            this.closeUploadDialog();
            this.completeUploadProcess();
            this.cd.detectChanges();
        });

        xhr.addEventListener("load", () => {
            // Clear mobile progress simulation on completion
            if (mobileProgressInterval) {
                clearInterval(mobileProgressInterval);
            }

            try {
                if (xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);
                    if (response.success && response.files) {
                        // Handle successful uploads
                        const successfulFiles = response.files;
                        let fileIndex = 0;

                        fileObjects.forEach((fileObj) => {
                            if (fileIndex < successfulFiles.length) {
                                fileObj.progress = 100;
                                fileObj.uploadStatus = UploadStatus.SUCCESS;
                                fileObj.fileId = successfulFiles[fileIndex].fileId;
                                fileObj.googleDriveLink = successfulFiles[fileIndex].publicLink;
                                fileIndex++;
                            } else {
                                fileObj.progress = 0;
                                fileObj.uploadStatus = UploadStatus.FAILED;
                            }
                        });

                        // Update progress tracking for completion
                        this.copyFileObjects.forEach((copyFileObj, index) => {
                            if (fileObjects[index] && fileObjects[index].uploadStatus === UploadStatus.SUCCESS) {
                                copyFileObj.progress = 100;
                            }
                        });

                        // Force final progress update and brief pause on mobile to show completion
                        this.calcUploadingPercentage();
                        this.cd.detectChanges();

                        if (isMobile) {
                            // On mobile, ensure user sees 100% completion with proper timing
                            setTimeout(() => {
                                // Show appropriate success/warning message
                                if (response.partialFailure) {
                                    this.toastr.warning(`${response.successfulUploads}/${response.totalFiles} files uploaded successfully. Some files failed.`);
                                    console.warn("Failed uploads:", response.failures);
                                } else {
                                    this.toastr.success(`${response.successfulUploads} file(s) uploaded to Google Drive successfully`);
                                }

                                // Additional delay to ensure user sees the success message and 100%
                                setTimeout(() => {
                                    this.closeUploadDialog();
                                    this.completeUploadProcess();
                                }, 2000); // 2 seconds to read success message
                            }, 1000); // 1 second to see 100% progress clearly
                            return; // Exit early to prevent immediate closure
                        }

                        // Show appropriate success/warning message
                        if (response.partialFailure) {
                            this.toastr.warning(`${response.successfulUploads}/${response.totalFiles} files uploaded successfully. Some files failed.`);
                            console.warn("Failed uploads:", response.failures);
                        } else {
                            this.toastr.success(`${response.successfulUploads} file(s) uploaded to Google Drive successfully`);
                        }
                    } else {
                        // Mark all as failed
                        fileObjects.forEach((fileObj) => {
                            fileObj.progress = 0;
                            fileObj.uploadStatus = UploadStatus.FAILED;
                        });
                        this.toastr.error("Upload failed: " + (response.error || "Unknown error"));
                    }
                } else {
                    // HTTP error - provide more detailed error messages
                    fileObjects.forEach((fileObj) => {
                        fileObj.progress = 0;
                        fileObj.uploadStatus = UploadStatus.FAILED;
                    });
                    let errorMsg = `Upload failed with status: ${xhr.status}`;
                    if (xhr.status === 401) {
                        errorMsg += " (Authentication failed - check Google Drive token)";
                    } else if (xhr.status === 413) {
                        errorMsg += " (Files too large)";
                    } else if (xhr.status === 403) {
                        errorMsg += " (Permission denied - check Google Drive permissions)";
                    }
                    this.toastr.error(errorMsg);
                }
            } catch (error) {
                console.error("Upload response parsing error:", error);
                fileObjects.forEach((fileObj) => {
                    fileObj.progress = 0;
                    fileObj.uploadStatus = UploadStatus.FAILED;
                });
                this.toastr.error("Upload failed: Invalid response from server");
            }

            // Update final progress and close dialog
            this.calcUploadingPercentage();

            if (isMobile) {
                // Brief delay on mobile for better UX
                setTimeout(() => {
                    this.closeUploadDialog();
                    this.completeUploadProcess();
                }, 500);
            } else {
                this.closeUploadDialog();
                this.completeUploadProcess();
            }
            this.cd.detectChanges();
        });

        xhr.addEventListener("error", () => {
            // Clear mobile progress simulation on error
            if (mobileProgressInterval) {
                clearInterval(mobileProgressInterval);
            }

            fileObjects.forEach((fileObj) => {
                fileObj.progress = 0;
                fileObj.uploadStatus = UploadStatus.FAILED;
            });
            this.toastr.error("Upload failed: Network error. Please check your internet connection.");
            this.calcUploadingPercentage();
            this.closeUploadDialog();
            this.completeUploadProcess();
            this.cd.detectChanges();
        });

        // Show upload start message
        this.toastr.info(`Starting upload of ${fileObjects.length} file(s) to Google Drive...`);

        xhr.open("POST", uploadUrl);
        xhr.send(formData);
    }

    openImagePreview(imageUrl: string, index: number, step: string) {
        // Create a full-screen image preview overlay
        const overlay = document.createElement("div");
        overlay.className = "image-fullscreen-overlay";
        overlay.innerHTML = `
            <div class="fullscreen-content">
                <div class="fullscreen-header">
                    <h3>${step === "step1" ? `תמונת רכב ${index + 1}` : `פגיעה ${index + 1}`}</h3>
                    <button class="close-btn" onclick="this.parentElement.parentElement.parentElement.remove()">
                        ✕ סגור
                    </button>
                </div>
                <div class="fullscreen-image-container">
                    <img src="${imageUrl}" alt="תמונה מוגדלת" onclick="event.stopPropagation()" />
                </div>
                <div class="fullscreen-actions">
                    <button class="delete-btn" onclick="window.deleteImageFromPreview(${index}, '${step}')">
                        🗑️ מחק תמונה
                    </button>
                </div>
            </div>
        `;

        // Add styles for the overlay
        const style = document.createElement("style");
        style.textContent = `
            .image-fullscreen-overlay {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.9);
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 9999;
                cursor: pointer;
            }
            .fullscreen-content {
                max-width: 95vw;
                max-height: 95vh;
                display: flex;
                flex-direction: column;
                align-items: center;
                cursor: default;
            }
            .fullscreen-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                padding: 20px;
                color: white;
            }
            .fullscreen-image-container {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .fullscreen-image-container img {
                max-width: 90vw;
                max-height: 70vh;
                object-fit: contain;
                border-radius: 8px;
            }
            .fullscreen-actions {
                padding: 20px;
            }
            .close-btn, .delete-btn {
                background: rgba(255, 255, 255, 0.1);
                border: 1px solid rgba(255, 255, 255, 0.3);
                color: white;
                padding: 10px 20px;
                border-radius: 6px;
                cursor: pointer;
                margin: 0 10px;
            }
            .close-btn:hover, .delete-btn:hover {
                background: rgba(255, 255, 255, 0.2);
            }
            .delete-btn {
                background: rgba(220, 53, 69, 0.3);
                border-color: #dc3545;
            }
            .delete-btn:hover {
                background: rgba(220, 53, 69, 0.5);
            }
        `;

        document.head.appendChild(style);
        document.body.appendChild(overlay);

        // Close on background click
        overlay.addEventListener("click", (e) => {
            if (e.target === overlay) {
                overlay.remove();
                style.remove();
            }
        });

        // Add delete functionality
        (window as any).deleteImageFromPreview = (imgIndex: number, stepName: string) => {
            if (stepName === "step1") {
                this.removeFileStep1(imgIndex);
            } else {
                this.removeFileStep2(imgIndex);
            }
            overlay.remove();
            style.remove();
        };
    }

    private completeUploadProcess() {
        // Set uploading flag to false
        this.uploading = false;

        // Build file URLs array for email integration
        this.filesUploaded = [];
        this.selectedFiles.forEach((fileObj) => {
            if (fileObj.uploadStatus === UploadStatus.SUCCESS && fileObj.googleDriveLink) {
                this.filesUploaded.push(fileObj.googleDriveLink);
            }
        });

        // Trigger final save process with Google Drive links
        if (this.filesUploaded.length > 0) {
            this.toastr.success(`Upload completed! ${this.filesUploaded.length} file(s) ready for report generation.`);
            // The report generation will use this.filesUploaded array with Google Drive links
            this.triggerFinalSave();
        } else {
            this.toastr.warning("Upload completed but no files were successfully processed.");
        }
    }

    private triggerFinalSave() {
        // Dispatch the final save with Google Drive links
        this.storeSelector.dispatch(
            actionSaveDynawebsEquipment({
                payload: {
                    version: this.version,
                    report: this.missingEquipmentSummary,
                    files: this.filesUploaded, // Google Drive links instead of S3 URLs
                    dateTime: this.dateNow,
                    officerId: this.officerId,
                    vehicleId: this.selectedVehicle.id,
                    userName: this.userName,
                    codeCall: this.selectedCodeCall,
                    data: this.form.value,
                    emailUser: this.selectedCaptain.email,
                    debug: isHostLocal() ? 1 : 0,
                },
            }),
        );

        // Listen for save completion
        this.actionsSubj.pipe(
            ofType(actionSaveDynawebsEquipmentSuccess, actionSaveFailedDynawebsEquipment),
            timeout(this.debugMode ? 5000 : 10000),
            take(1),
            catchError(err => {
                this.debouncedProblemSavingDialog("timeout");
                return of(null);
            }),
        ).subscribe(reply => {
            if (reply && reply.payload && reply.payload.saved) {
                this.toastr.success("Equipment report saved successfully");
                this.viewMode = EnumViewMode.COMPLETED;
            } else {
                this.debouncedProblemSavingDialog("server error");
            }
            this.cd.detectChanges();
        });
    }

    private async updateResource() {
        let uploadingNow = false;
        let duration = "0";

        for (const fileObj of this.selectedFiles) {
            if (fileObj.uploadStatus === UploadStatus.SUCCESS) {
                if (SUPPORTED_FILE_TYPES.indexOf(fileObj.fileType.toLowerCase()) === -1) {
                    continue;
                }
                // If it's video, get the duration
                if (fileObj.fileType.toLowerCase() === "mp4") {
                    duration = await this.getVideoDuration(fileObj);
                }

                const updatedRes: IResourceUpload = {
                    resource_name: `${this.selectedVehicle.id}_${new Date()
                        .toISOString()
                        .replace(/[^0-9]/g, "")}`,
                    resource_type: fileObj.fileType,
                    default_player: this.storeSelector.getBlockLabelByFileType(
                        fileObj.fileType.toLowerCase(),
                    ).id as any,
                    resource_total_time: duration,
                    resource_date_created: String(new Date().getTime()),
                    resource_date_modified: String(new Date().getTime()),
                    resource_bytes_total: String(fileObj.fileSize),
                    access_key: "0",
                    tree_path: this.category,
                };

                const saveRecord: ICRUDRecord = {
                    studioId: this.studioId,
                    command: "update",
                    primary: "resource_id",
                    table: "resources",
                    body: updatedRes,
                    id: fileObj.fileId,
                    overrideCredentials: this.overrideCredentials,
                };

                fileObj.uploadStatus = UploadStatus.UPDATING;
                // Use Google Drive public link instead of S3 URL
                const urlImage = fileObj.googleDriveLink || `https://drive.google.com/uc?id=${fileObj.fileId}`;
                this.filesUploaded.push(urlImage);

                this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
                    if (!i_crudReply.serverReply.status) return;
                    updatedRes["resource_id"] = String(fileObj.fileId);
                    updatedRes["id"] = String(fileObj.fileId);
                    updatedRes["changelist_id"] = String(
                        i_crudReply.serverReply.changelist_id,
                    );
                    this.storeSelector.dispatch(actionAddResources({ data: updatedRes as IResource }));
                    this.deleteFile(fileObj.fileId);
                });
            }
            if (fileObj.uploadStatus === UploadStatus.INPROGRESS) {
                uploadingNow = true;
            }
        }

        this.uploading = uploadingNow;

        if (!uploadingNow) {
            this.closeUploadDialog();
            // Dispatch the final save with the server
            this.storeSelector.dispatch(
                actionSaveDynawebsEquipment({
                    payload: {
                        version: this.version,
                        report: this.missingEquipmentSummary,
                        files: this.filesUploaded,
                        dateTime: this.dateNow,
                        officerId: this.officerId,
                        vehicleId: this.selectedVehicle.id,
                        userName: this.userName,
                        codeCall: this.selectedCodeCall,
                        data: this.form.value,
                        emailUser: this.selectedCaptain.email,
                        debug: isHostLocal() ? 1 : 0,
                    },
                }),
            );

            // Listen for the save response (assumes you have a success/failure action for save)

            this.actionsSubj.pipe(
                ofType(actionSaveDynawebsEquipmentSuccess, actionSaveFailedDynawebsEquipment),
                timeout(this.debugMode ? 5000 : 10000), // Wait for 10 seconds for a reply
                take(1),
                catchError(err => {
                    // Timeout occurred, so handle as a failure
                    this.debouncedProblemSavingDialog("timeout");
                    return of(null);
                }),
            ).subscribe(reply => {
                if (reply && reply.payload && reply.payload.saved) {
                    // Success branch
                    this.toastr.success("שמר נתונים");
                    this.viewMode = EnumViewMode.COMPLETED;
                } else {
                    this.debouncedProblemSavingDialog("server error");

                    // optional let server know of the issue so it deletes db entry
                    // this.storeSelector.dispatch(
                    //     actionSaveFailedRemoveDynawebsEquipment({
                    //         payload: {
                    //             version: this.version,
                    //             report: this.missingEquipmentSummary,
                    //             dateTime: this.dateNow,
                    //             officerId: this.officerId,
                    //             vehicleId: this.selectedVehicle.id,
                    //             userName: this.userName,
                    //             codeCall: this.selectedCodeCall,
                    //             data: this.form.value,
                    //             emailUser: this.selectedCaptain.email,
                    //             debug: isHostLocal() ? 1 : 0
                    //         }
                    //     })
                    // );
                }
                this.cd.detectChanges();
            });
        }
        this.cd.detectChanges();
    }

    private problemSavingDialog(i_err: string) {
        this.toastr.error("נתקלנו בבעיה אנא צלמו את הניידת ושימרו שוב", i_err, { timeOut: 10000 });
        // Reset file statuses if needed
        this.selectedFiles.forEach(fileObj => {
            if (fileObj.uploadStatus === UploadStatus.FAILED) {
                fileObj.uploadStatus = UploadStatus.READY;
                fileObj.progress = 0;
            }
        });
        this.uploadModalRef = this.dialog.open(this.problemSaving, {
            height: "290px",
            width: "400px",
            data: {},
        });
        // optional
        // this.storeSelector.dispatch(
        //     actionSaveFailedDynawebsEquipment({
        //         payload: {
        //             version: this.version,
        //             report: this.missingEquipmentSummary,
        //             dateTime: this.dateNow,
        //             officerId: this.officerId,
        //             vehicleId: this.selectedVehicle.id,
        //             userName: this.userName,
        //             codeCall: this.selectedCodeCall,
        //             data: this.form.value,
        //             emailUser: this.selectedCaptain.email,
        //             debug: isHostLocal() ? 1 : 0
        //         }
        //     })
        // );;
    }

    private closeUploadDialog() {
        if (this.uploadModalRef) {
            this.uploadModalRef.close();
        }
        this.copyFileObjects = [];
    }

    private calcUploadingPercentage() {
        const uploadedFileSize = this.copyFileObjects.reduce((size, fileObj) => {
            const progress = fileObj.progress || 0;
            return size + (fileObj.fileSize * progress) / 100;
        }, 0);

        this.formattedUploadingSize = formatBytes(uploadedFileSize, 2);

        if (!this.totalFileSize || this.totalFileSize === 0) {
            this.uploadPercentage = 0;
        } else {
            this.uploadPercentage = Math.round((uploadedFileSize / this.totalFileSize) * 100);
        }
    }

    private async getVideoDuration(i_file: FileObj): Promise<any> {
        return new Promise((resolve, reject) => {
            try {
                const video = document.createElement("video");
                video.preload = "metadata";
                video.onloadedmetadata = () => {
                    window.URL.revokeObjectURL(video.src);
                    resolve(Lib.ParseToFloatDouble(video.duration));
                };
                video.onerror = () => {
                    resolve(0);
                };
                video.src = URL.createObjectURL(i_file.file);
            } catch (e) {
                reject(e);
            }
        });
    }

    /**
     * This method compresses an image if it's above the maxSize threshold.
     * By default, we pass in `this.IMAGE_MAX_SIZE_MB * 1024 * 1024` as maxSize.
     * If ANY error occurs (in reading the file, in canvas, etc.), we fall back
     * to returning the ORIGINAL file uncompressed.
     */
    private async compressImageFile(
        file: File,
        maxSize = this.IMAGE_MAX_SIZE_MB * 1024 * 1024,
    ): Promise<File> {
        // Apply low bandwidth settings if enabled
        if (this.useLowBandwidthMode) {
            maxSize = this.LOW_BANDWIDTH_MAX_SIZE_MB * 1024 * 1024;
        }

        // If compression is off or file is already below the limit, just return as is.
        if (!this.IMAGE_COMPRESS || file.size <= maxSize) {
            return file;
        }

        try {
            return await new Promise<File>((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event: any) => {
                    try {
                        const img = new Image();
                        img.onload = () => {
                            try {
                                const canvas = document.createElement("canvas");
                                const ctx = canvas.getContext("2d");
                                if (!ctx) {
                                    // If we fail to get context, fallback to original
                                    return reject(new Error("Canvas context not found."));
                                }

                                // Resize dimensions if low bandwidth mode is enabled
                                let targetWidth = img.width;
                                let targetHeight = img.height;

                                if (this.useLowBandwidthMode) {
                                    const maxDimension = this.LOW_BANDWIDTH_MAX_DIMENSION;
                                    if (targetWidth > maxDimension || targetHeight > maxDimension) {
                                        const ratio = Math.min(maxDimension / targetWidth, maxDimension / targetHeight);
                                        targetWidth = Math.floor(targetWidth * ratio);
                                        targetHeight = Math.floor(targetHeight * ratio);
                                    }
                                }

                                // Draw image into canvas with potentially reduced dimensions
                                canvas.width = targetWidth;
                                canvas.height = targetHeight;
                                ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

                                // Start with lower quality in low bandwidth mode
                                let quality = this.useLowBandwidthMode ? 0.7 : 0.92;

                                const attemptCompression = () => {
                                    const dataUrl = canvas.toDataURL("image/jpeg", quality);
                                    const byteString = atob(dataUrl.split(",")[1]);
                                    const arrayBuffer = new ArrayBuffer(byteString.length);
                                    const intArray = new Uint8Array(arrayBuffer);

                                    for (let i = 0; i < byteString.length; i++) {
                                        intArray[i] = byteString.charCodeAt(i);
                                    }
                                    const compressedBlob = new Blob([intArray], { type: "image/jpeg" });

                                    // Check size
                                    if (compressedBlob.size <= maxSize || quality < 0.3) {
                                        // Good enough, or can't compress further
                                        const newFile = new File(
                                            [compressedBlob],
                                            file.name.replace(/\.\w+$/, ".jpg"),
                                            { type: "image/jpeg", lastModified: Date.now() },
                                        );
                                        resolve(newFile);
                                    } else {
                                        // Decrease quality slightly and try again
                                        quality -= 0.05;
                                        attemptCompression();
                                    }
                                };

                                // Start the compression attempts
                                attemptCompression();
                            } catch (canvasErr) {
                                // If something breaks in the drawing process
                                reject(canvasErr);
                            }
                        };

                        img.onerror = (err) => reject(err);
                        img.src = event.target.result as string;
                    } catch (imgErr) {
                        reject(imgErr);
                    }
                };

                reader.onerror = (fileErr) => reject(fileErr);
                reader.readAsDataURL(file);
            });
        } catch (e) {
            // If ANYTHING goes wrong at all, we log if needed and return the original file.
            if (this.debugMode) {
                console.error("Error compressing file, returning original file:", e);
            }
            return file;
        }
    }


    /**
     * Helper to convert a File to a base64 dataURL (for preview, if needed).
     */
    private fileToDataURL(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result as string);
            };
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
        });
    }

    /**
     *  Capture <input type="file" accept="image/*" capture="environment">
     *  Potentially compress each image if IMAGE_COMPRESS is true,
     *  then store for upload + create base64 previews.
     */
    async onFilesSelected(event: Event): Promise<void> {
        const input = event.target as HTMLInputElement;
        if (!input.files) return;

        for (const file of Array.from(input.files)) {
            // Respect your limit
            if (this.selectedFiles.length >= LIMIT_UPLOADS_COUNT) {
                this.toastr.warning(
                    this.translocoService.translate("toast.limitUploads", {}, this.translocoService.getActiveLang()),
                );
                continue;
            }

            // 1) Start “busy” for compression
            this.imagesBusyCount++;
            this.updateLesikumButtonDisabledState(); // disable while compressing

            let finalFile: File = file;
            // 2) Try compressing:
            try {
                if (this.IMAGE_COMPRESS) {
                    finalFile = await this.compressImageFile(file);
                }
            } catch (e) {
                // If compression fails, fallback to original
                if (this.debugMode) {
                    console.error("Error compressing file, using original:", e);
                }
                finalFile = file;
            } finally {
                // 3) Done compressing – decrement
                this.imagesBusyCount--;
                this.updateLesikumButtonDisabledState();
            }

            // 4) Convert the finalFile to base64 preview
            const previewDataUrl = await this.fileToDataURL(finalFile);
            this.imageData.push(previewDataUrl);

            // 5) Create a FileObj to track upload progress
            const fileName = restrictSingleQuote(finalFile.name).split(".").slice(0, -1).join(".");
            const fileExt = finalFile.name.split(".").pop() || "jpg";

            const obj: FileObj = {
                fileName,
                fileType: fileExt,
                file: finalFile,
                fileId: `${fileName}-${finalFile.lastModified}`,
                progress: 0,
                uploadStatus: UploadStatus.READY,
                formattedSize: formatBytes(finalFile.size, 2),
                fileSize: finalFile.size,
            };

            this.selectedFiles.push(obj);
            this.cd.detectChanges();
        }

        // Final check after all files
        this.updateLesikumButtonDisabledState();
    }

    removeFile(index: number): void {
        this.imageData.splice(index, 1);
        this.selectedFiles.splice(index, 1);

        // <-- Call the same method used for recalculating the button's disabled state.
        this.updateLesikumButtonDisabledState();
    }

    uploadFiles() {
        if (!this.selectedFiles || this.selectedFiles.length === 0) {
            this.toastr.error("חסר צילום");
            return;
        }
        // If everything is already SUCCESS, do nothing
        if (
            this.selectedFiles.filter((obj) => obj.uploadStatus !== UploadStatus.SUCCESS).length === 0
        ) {
            return;
        }
        this.uploading = true;
        this.uploadSelectedFiles();
    }

    // onSubmit() {
    //     this.createReport();
    //     this.uploadFiles();
    // }

    onSubmit() {
        this.createReport();

        // combine both photo‐steps into the original arrays
        this.selectedFiles = [
            ...this.selectedFilesStep1,
            ...this.selectedFilesStep2,
        ];
        this.imageData = [
            ...this.imageDataStep1,
            ...this.imageDataStep2,
        ];

        this.uploadFiles();
    }

    resetFormControlsPage2() {
        setTimeout(() => {
            Object.entries(this.form.controls).forEach(([controlName, control]) => {
                // Example: if you need to reset wizard2 fields, adapt logic here
                if (controlName.includes("wizard2")) {
                    control.markAsPristine();
                    control.markAsUntouched();
                    control.updateValueAndValidity();
                }
            });
        }, 100);
    }

    allControlsAllWizardsCheck() {
        setTimeout(() => {
            this.allControlsTouchedPage1(null);
            this.allControlsTouchedPage2(null);
        }, 333);
    }

    allControlsTouchedPage1(triggeredName?: string): void {
        let ready = 0;

        // If the caller passes a specific control name, mark it as touched.
        if (triggeredName) {
            this.form.controls[triggeredName].markAsTouched();
        }

        // 1) Get all Wizard1 items that must be validated: checkPage1 === 1
        const wizard1Items = this.inv.filter(item => item.checkPage1 === 1);

        // 2) Loop each relevant item
        for (const item of wizard1Items) {
            const ctrlName = item.name;
            const control = this.form.controls[ctrlName];

            // If the item has a "checkLength" property, we enforce min length
            if (item.checkLength) {
                // Example: if checkLength is 2, we require at least length >= 2
                if (!this.checkString(control.value, item.checkLength)) {
                    ready++;
                    continue; // skip further checks for this item
                }
            } else {
                // If no "checkLength" is specified, require that user at least touched the field
                if (!control.touched) {
                    ready++;
                    continue;
                }
            }
        }

        // If any item fails, wizardDisabled1 = true (unless debugMode).
        this.wizardDisabled1 = (ready !== 0) && !this.debugMode;
    }


    allControlsTouchedPage2(triggeredName: string): void {
        let ready = 0;

        // If a caller passes `triggeredName`, mark that control as touched:
        if (triggeredName) {
            this.form.controls[triggeredName].markAsTouched();
        }

        // 1) Filter `inv` for items flagged with `checkPage2: 1`.
        const page2Items = this.inv.filter(item => item.checkPage2 === 1);

        // 2) Loop each relevant item:
        for (const item of page2Items) {
            const ctrlName = item.name;
            const control = this.form.controls[ctrlName];

            // (a) If the item has a "checkLength" property,
            //     ensure the string length >= checkLength
            if (item.checkLength) {
                if (!this.checkString(control.value, item.checkLength)) {
                    ready++;
                    continue; // skip further checks for this item
                }
            }
            // (b) Otherwise, just require that it's touched:
            else {
                if (!control.touched) {
                    ready++;
                    continue;
                }
            }
        }

        if (!this.debugMode) {
            this.wizardDisabled2 = (ready !== 0);
        }
    }


    reload() {
        window.location.reload();
    }

    fetchSheetData(): Observable<any[]> {
        return this.http.get(this.sheetUrl, { responseType: "text" }).pipe(
            map((csvData) => {
                const parsedData = Papa.parse(csvData, {
                    header: true,
                    skipEmptyLines: true,
                });
                // Filter out empty rows
                return parsedData.data.filter((row) =>
                    Object.values(row).some((value) => value),
                );
            }),
        );
    }

    formatSummaryDataToText(data: { name: string; value: any }[]): string {
        // 1) Set up an icon map for the field names you'll output
        const iconMap: Record<string, string> = {
            "ע\"י": "👤",
            "קוד קריאה": "📌",
            "נידת": "🚔",
            "קילומטראז": "🚖",
            "מספר_נשק": "🔫",
            "מספר_נשק2": "🔫",
            "אזיק_רגליים": "🔗",
            "מספר_טייזר": "⚡",
            "מספר_טאבלט": "📱",
            "מספר_קשר1": "📻",
            "מספר_קשר2": "📻",

        };

        let result = "";

        // 2) Print top lines for user, code call, vehicle
        //    (i.e., "ע"י", "קוד קריאה", and "נידת"). Only once, no duplicates.
        result += `👤 ע"י: ${this.userName}\n`;           // e.g. ע"י: שחר
        result += `📌 קוד קריאה: ${this.selectedCodeCall}\n`; // e.g. 000
        if (this.selectedVehicle?.id) {
            result += `🚔 נידת: ${this.selectedVehicle.id}\n`;   // e.g. 25-168
        }

        // 3) Loop through data for the rest
        for (const item of data) {
            const fieldName = item.name ?? "";
            let fieldValue = item.value ?? "";

            // (a) Skip if we've already handled these top-line fields
            if (fieldName === "ע\"י" || fieldName === "קוד קריאה" || fieldName === "נידת") {
                // We printed them already, so continue
                continue;
            }

            // (b) Convert empty string or booleans
            if (fieldValue === "") fieldValue = "---";
            if (fieldValue === true) fieldValue = "1";
            if (fieldValue === false) fieldValue = "0";

            // (c) Find icon if it exists
            const icon = iconMap[fieldName] || "";

            // (d) Print line => e.g. "🔗 אזיק_רגליים: 77777"
            result += `${icon ? icon + " " : ""}${fieldName}: ${fieldValue}\n`;
        }

        // 4) Add any bottom lines you want
        // result += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
        result += `\n🚓 לזיווד: tinyurl.com/zivudim`;
        // result += `https://secure.digitalsignage.com/levtlv.html\n`;
        // result += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;

        // result += `📜 היסטורית זיוודים:\n`;
        // result += `https://secure.digitalsignage.com/levtlv.html\n`;
        // result += `https://galaxy.signage.me/signstudio/shopping-cart/equipment\n`;
        // result += `https://secure.digitalsignage.com/reportEquipment?days=3\n`;
        // result += `━━━━━━━━━━━━━━━━━\n`;

        return result;
    }


    // formatSummaryDataToText(data) {
    //     let result = ``;
    //     data.forEach(item => {
    //         const name = item.name ?? '';
    //         let value = item.value !== undefined ? item.value : '';
    //         if (value === 'f') {
    //             value = '---';
    //         } else if (value === 't') {
    //             value = 'קים';
    //         }
    //         if (value === '') {
    //             value = '---';
    //         }
    //         result += `${name}: ${value}\n`;
    //     });
    //     return result;
    // }

    copyForm() {
        const report = this.copyEndShiftReport(this.secondTabForm.value);
        copyTextClipboard(report);
        this.toastr.info("עכשיו הדבק את הבחירות וההערות לוואטסאפ");
    }

    copyEndShiftReport(form: {
        drop1: number;
        drop2: number;
        drop3: number;
        drop4: number;
        comments?: string;
    }): string {
        const iconMap: Record<string, string> = {
            "קוד קריאה": "📌",
            אירועים: "🚨",
            רכבים: "🚗",
            "דו-גלגלי": "🛴",
            אדם: "🧍",
            הערות: "📝",
        };

        const lines = [
            // emoji first (rightmost), then space, then label and value
            `${iconMap["קוד קריאה"]} קוד קריאה: ${this.selectedCodeCall}`,
            `${iconMap["אירועים"]} אירועים: ${form.drop1}`,
            `${iconMap["רכבים"]} רכבים: ${form.drop2}`,
            `${iconMap["דו-גלגלי"]} דו-גלגלי: ${form.drop3}`,
            `${iconMap["אדם"]} אדם: ${form.drop4}`,
        ];

        if (form.comments) {
            lines.push(`${iconMap["הערות"]} הערות: ${form.comments}`);
        }

        return lines.join("\n");
    }


    copyTable() {
        const report = this.formatSummaryDataToText(this.equipmentSummary);
        copyTextClipboard(report);
        this.toastr.info("עכשיו הדבק סיכום ציוד לוואטסאפ");
    }

    onBackspace(event: Event, index: number, container?: number): void {
        if (!container) {
            // Original behavior for login input
            if (index > 0 && this.inputValues[index] === "") {
                const prevInput = this.inputBoxes.toArray()[index - 1][
                    "nativeElement"
                    ] as HTMLInputElement;
                prevInput.focus();
            }
            return;
        }

        // Handle the 3 verification containers
        const inputValues = container === 1 ? this.inputValues1 : container === 2 ? this.inputValues2 : this.inputValues3;
        const inputBoxes = container === 1 ? this.inputBoxes1 : container === 2 ? this.inputBoxes2 : this.inputBoxes3;

        if (index > 0 && inputValues[index] === "") {
            const prevInput = inputBoxes.toArray()[index - 1]["nativeElement"] as HTMLInputElement;
            prevInput.focus();
        }

        // Update validation state after backspace (with slight delay to ensure value is cleared)
        setTimeout(() => {
            // Reset validation if user is editing
            if (container === 1) this.serialValid1 = null;
            else if (container === 2) this.serialValid2 = null;
            else if (container === 3) this.serialValid3 = null;
            this.checkInputVerifyComplete();
        }, 10);
    }

    clearInputs(container?: number): void {
        if (!container) {
            // Original behavior for login input
            this.inputValues = ["", "", "", "", "", ""];
            const firstInput = this.inputBoxes.first["nativeElement"] as HTMLInputElement;
            firstInput.focus();
            return;
        }

        // Handle the 3 verification containers
        if (container === 1) {
            this.inputValues1 = ["", "", "", "", "", ""];
            this.serialValid1 = null;
            if (this.inputBoxes1?.first) {
                const firstInput = this.inputBoxes1.first["nativeElement"] as HTMLInputElement;
                firstInput.focus();
            }
        } else if (container === 2) {
            this.inputValues2 = ["", "", "", "", "", ""];
            this.serialValid2 = null;
            if (this.inputBoxes2?.first) {
                const firstInput = this.inputBoxes2.first["nativeElement"] as HTMLInputElement;
                firstInput.focus();
            }
        } else if (container === 3) {
            this.inputValues3 = ["", "", "", "", "", ""];
            this.serialValid3 = null;
            if (this.inputBoxes3?.first) {
                const firstInput = this.inputBoxes3.first["nativeElement"] as HTMLInputElement;
                firstInput.focus();
            }
        }

        // Update validation state after clearing
        this.checkInputVerifyComplete();
    }

    onInput(event: Event, index: number, container?: number): void {
        if (!container) {
            // Original behavior for login input
            const input = event.target as HTMLInputElement;
            this.inputValues[index] = input.value;
            if (input.value.length === 1) {
                if (index < this.inputValues.length - 1) {
                    const nextInput = this.inputBoxes.toArray()[index + 1][
                        "nativeElement"
                        ] as HTMLInputElement;
                    nextInput.focus();
                }
            }
            this.inputValuesReady = this.inputValues.every(value => /^[0-9]$/.test(value));
            return;
        }

        // Handle the 3 verification containers
        const input = event.target as HTMLInputElement;
        const inputValues = container === 1 ? this.inputValues1 : container === 2 ? this.inputValues2 : this.inputValues3;
        const inputBoxes = container === 1 ? this.inputBoxes1 : container === 2 ? this.inputBoxes2 : this.inputBoxes3;

        inputValues[index] = input.value;

        if (input.value.length === 1) {
            if (index < inputValues.length - 1) {
                const nextInput = inputBoxes.toArray()[index + 1]["nativeElement"] as HTMLInputElement;
                nextInput.focus();
            } else if (index === inputValues.length - 1) {
                // Last digit entered - validate the serial number
                this.validateSerialNumber(container);
            }
        }

        // Validate if 6 digits are complete
        if (inputValues.every(value => /^[0-9]$/.test(value))) {
            this.validateSerialNumber(container);
        } else {
            // Reset validation if not complete
            if (container === 1) this.serialValid1 = null;
            else if (container === 2) this.serialValid2 = null;
            else if (container === 3) this.serialValid3 = null;
        }

        // Check if all 3 containers are complete
        this.checkInputVerifyComplete();
    }

    checkInputVerifyComplete(): void {
        // Skip serial verification if inSerialDev is disabled
        if (!this.inSerialDev) {
            this.inputVerifyComplete = true;
            return;
        }

        // Skip serial verification in debug/test mode (local host)
        if (isHostLocal()) {
            this.inputVerifyComplete = true;
            return;
        }

        const allValues1Complete = this.inputValues1.every(value => /^[0-9]$/.test(value));
        const allValues2Complete = this.inputValues2.every(value => /^[0-9]$/.test(value));
        const allValues3Complete = this.inputValues3.every(value => /^[0-9]$/.test(value));

        // Only consider complete if all values are filled AND valid
        const allValid = this.serialValid1 === true && this.serialValid2 === true && this.serialValid3 === true;
        this.inputVerifyComplete = allValues1Complete && allValues2Complete && allValues3Complete && allValid;
    }

    validateSerialNumber(container: number): void {
        const serial1 = this.inputValues1.join('');
        const serial2 = this.inputValues2.join('');
        const serial3 = this.inputValues3.join('');

        if (container === 1) {
            const serial = serial1;
            if (serial.length === 6) {
                // Check if valid AND not used in other containers
                const isValid = this.serialVerifications.bulletProofVest.includes(serial);
                const isDuplicate = serial === serial2 || serial === serial3;
                this.serialValid1 = isValid && !isDuplicate;
            } else {
                this.serialValid1 = null;
            }
        } else if (container === 2) {
            const serial = serial2;
            if (serial.length === 6) {
                // Check if valid AND not used in other containers
                const isValid = this.serialVerifications.bulletProofVest.includes(serial);
                const isDuplicate = serial === serial1 || serial === serial3;
                this.serialValid2 = isValid && !isDuplicate;
            } else {
                this.serialValid2 = null;
            }
        } else if (container === 3) {
            const serial = serial3;
            if (serial.length === 6) {
                // Check if valid AND not used in other containers
                const isValid = this.serialVerifications.roadCones.includes(serial);
                const isDuplicate = serial === serial1 || serial === serial2;
                this.serialValid3 = isValid && !isDuplicate;
            } else {
                this.serialValid3 = null;
            }
        }

        // Revalidate all containers to update duplicate status
        // This ensures that if container 1 has "100100" and user types "100100" in container 2,
        // both get marked as invalid (duplicate)
        if (container !== 1 && serial1.length === 6) {
            const isValid = this.serialVerifications.bulletProofVest.includes(serial1);
            const isDuplicate = serial1 === serial2 || serial1 === serial3;
            this.serialValid1 = isValid && !isDuplicate;
        }
        if (container !== 2 && serial2.length === 6) {
            const isValid = this.serialVerifications.bulletProofVest.includes(serial2);
            const isDuplicate = serial2 === serial1 || serial2 === serial3;
            this.serialValid2 = isValid && !isDuplicate;
        }
        if (container !== 3 && serial3.length === 6) {
            const isValid = this.serialVerifications.roadCones.includes(serial3);
            const isDuplicate = serial3 === serial1 || serial3 === serial2;
            this.serialValid3 = isValid && !isDuplicate;
        }

        // Update overall completion status after validation
        this.checkInputVerifyComplete();
    }

    onLoginCheck(v?: string) {
        let acc;
        if (v) {
            acc = v;
        } else {
            acc = this.inputValues.join("");
        }
        if (acc.toLowerCase() === EQUIP_ACCESS) {
            this.viewMode = EnumViewMode.CHECKING_1;
            // this.viewMode = EnumViewMode.COMPLETED;
            this.localStoreService.setStorageValConfig("equipmentAccess", acc);
        }
    }

    start() {
        if (!this.selectedVehicle || !this.officerId) {
            this.toastr.warning("חסר נתונים");
            return;
        }
        if (this.selectedVehicle.id.length < 5 || this.officerId.length < 5) {
            this.toastr.warning("חסר נתונים");
            return;
        }
        this.viewMode = EnumViewMode.CHECKING_2;
        this.localStoreService.setStorageValConfig("equipmentUser", this.userName);
        this.localStoreService.setStorageValConfig("equipmentId", String(this.officerId));
        this.storeSelector.dispatch(actionLoadDynawebsEquipment({ payload: this.selectedVehicle.id }));
    }

    getDate() {
        const date = new Date();
        return date.toLocaleString("he-IL", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        });
    }

    onTikPizorChange(event: any) {
        console.log("Checkbox change event:", event); // Debug log
        const isChecked = event.checked;
        this.tikPizorSelected = isChecked;

        if (isChecked) {
            // Set all 4 dropdowns to value "2" (max value)
            this.form.get("אלה")?.setValue("2");
            this.form.get("קסדה")?.setValue("2");
            this.form.get("אפוד_מגן")?.setValue("2");
            this.form.get("אפוד_קרמי")?.setValue("2");

            // Mark them as touched for validation
            this.form.get("אלה")?.markAsTouched();
            this.form.get("קסדה")?.markAsTouched();
            this.form.get("אפוד_מגן")?.markAsTouched();
            this.form.get("אפוד_קרמי")?.markAsTouched();
        } else {
            // Reset values when unchecked
            this.form.get("אלה")?.setValue("0");
            this.form.get("קסדה")?.setValue("0");
            this.form.get("אפוד_מגן")?.setValue("0");
            this.form.get("אפוד_קרמי")?.setValue("0");
        }

        // Call your existing validation method
        this.allControlsTouchedPage1("תיק_פיזור");
    }

    onTikiyotChange(event: any) {
        console.log("תיקיות checkbox change event:", event); // Debug log
        const isChecked = event.checked;
        this.tikiyotSelected = isChecked;

        if (isChecked) {
            // Set all 3 dropdowns to value "1" (max value)
            this.form.get("תיק_מחסומים")?.setValue("1");
            this.form.get("תיק_סיור")?.setValue("1");
            this.form.get("תיק_שטח")?.setValue("1");

            // Mark them as touched for validation
            this.form.get("תיק_מחסומים")?.markAsTouched();
            this.form.get("תיק_סיור")?.markAsTouched();
            this.form.get("תיק_שטח")?.markAsTouched();
        } else {
            // Reset values when unchecked
            this.form.get("תיק_מחסומים")?.setValue("0");
            this.form.get("תיק_סיור")?.setValue("0");
            this.form.get("תיק_שטח")?.setValue("0");
        }

        // Call your existing validation method
        this.allControlsTouchedPage1("תיקיות");
    }

    setKitatKonenoot(e) {
        this.kitatKonenut = e.checked;
        // If "כיתת כוננות" is checked, optionally pre-fill certain fields
        if (this.kitatKonenut) {
            this.form.controls["מספר_נשק2"].disable();
            this.form.controls["אזיק_רגליים"].disable();
            this.form.controls["מספר_טייזר"].disable();
            this.form.controls["מספר_טאבלט"].disable();
            this.form.controls["מספר_קשר2"].disable();
            this.form.controls["מספר_קשר1"].setValue("000000");
            this.allControlsTouchedPage1("מספר_קשר1");
            this.form.controls["מספר_טאבלט"].setValue("000000");
            this.allControlsTouchedPage1("מספר_טאבלט");
            this.form.controls["מספר_נשק"].setValue("000000");
            this.allControlsTouchedPage1("מספר_נשק");
        } else {
            this.form.controls["מספר_נשק2"].enable();
            this.form.controls["אזיק_רגליים"].enable();
            this.form.controls["מספר_טייזר"].enable();
            this.form.controls["מספר_טאבלט"].enable();
            this.form.controls["מספר_קשר2"].enable();
            this.form.controls["מספר_קשר1"].setValue("");
            this.allControlsTouchedPage1("מספר_קשר1");
            this.form.controls["מספר_טאבלט"].setValue("");
            this.allControlsTouchedPage1("מספר_טאבלט");
            this.form.controls["מספר_נשק"].setValue("");
            this.allControlsTouchedPage1("מספר_נשק");
        }
    }

    installPwa() {
        this.localStoreService.setStorageValConfig("equipmentPwa", "1");
        this.appService.installPwa();
    }

    clearPwa() {
        this.localStoreService.setStorageValConfigGroup([
            { key: "equipmentPwa", val: "0" },
            { key: "equipmentUser", val: "" },
            { key: "equipmentAccess", val: "" },
            { key: "equipmentId", val: "" },
        ]);
    }

    createReport() {
        this.missingEquipmentSummary = [];
        const added = [];
        this.equipmentSummary = [];

        // Optional: If you always want to show 'קוד קריאה' + 'נידת' at the top, push them now:
        this.equipmentSummary.push({ name: "ע\"י", value: this.userName });
        this.equipmentSummary.push({ name: "קוד קריאה", value: this.selectedCodeCall });
        this.equipmentSummary.push({ name: "נידת", value: this.selectedVehicle.id });
        this.equipmentSummary.push({ name: "קילומטראז", value: this.form.controls["קילומטראז"].value });

        // 1) Loop over every key in the form
        for (const key of Object.keys(this.form.value)) {
            const invItem = this.inv.find(item => item.name === key);
            if (!invItem) continue; // skip if no match in `inv`

            // 2) If it's 'date' => skip
            if (key === "date") continue;

            // 3) If it's 'הערות', sanitize and skip or push if needed
            if (key === "הערות") {
                if (this.form.value["הערות"]) {
                    try {
                        const dangerousPattern = /\b(?:eval|shell_exec|system|passthru|exec)\b|[./\\]/gi;
                        this.form.value["הערות"] = this.form.value["הערות"].replace(dangerousPattern, "");
                    } catch (e) {
                        console.error("problem regexp process comments");
                    }
                }
                // If you don’t want to push הערות to any summary, just continue
                continue;
            }

            // 4) Convert booleans to 1/0
            let currentStock = this.form.value[key];
            if (currentStock === true) currentStock = 1;
            if (currentStock === false) currentStock = 0;

            // 5) If item has equipmentSummary === 1 => push to equipmentSummary
            if (invItem.equipmentSummary === 1) {
                this.equipmentSummary.push({
                    name: invItem.name,
                    value: currentStock,
                });
            }

            // 6) If addToReport === 1 => do missingEquipment logic
            if (invItem.addToReport === 1) {
                if (!added.includes(key)) {
                    if (invItem.maxStock != null) {
                        // parse if numeric
                        if (!isNaN(parseInt(currentStock))) {
                            currentStock = parseInt(currentStock, 10);
                        }
                        // if different => push missing
                        if (currentStock !== invItem.maxStock) {
                            added.push(key);
                            this.missingEquipmentSummary.push({
                                item: key,
                                expect: invItem.maxStock,
                                current: currentStock,
                                missing: invItem.maxStock - currentStock,
                            });
                        }
                    }
                }
            }
        }
    }

    deleteFile(fileId) {
        const i = this.selectedFiles.findIndex((file) => file.fileId === fileId);
        if (i > -1) {
            this.selectedFiles.splice(i, 1);
            this.imageData.splice(i, 1);
            this.cd.detectChanges();
        }
    }

    private setDebugging() {
        this.debugMode = true;
        this.wizardDisabled1 = false;
        this.wizardDisabled2 = false;
        this.selectedCodeCall = "000";
        // For quick debug
        setTimeout(() => {
            this.selectedVehicle = this.vehicles[0];
            this.selectedCaptain = this.emailSendTo[0];
            this.selectedCodeCall = this.callIds[0];
            this.selectedCodeCall = "000";
        }, 1500);
    }


    masterToggleGroup(side: "left" | "right", isChecked: boolean) {
        const group = side === "left" ? this.leftCheckboxes : this.rightCheckboxes;
        group.forEach((ctrlName) => {
            // Set child to 'true' or 'false'
            this.form.controls[ctrlName].setValue(isChecked);
            // Mark as touched if you need your wizard logic
            this.form.controls[ctrlName].markAsTouched();
        });
        this.allControlsTouchedPage2("");
    }

    isGroupAllChecked(side: "left" | "right"): boolean {
        const group = side === "left" ? this.leftCheckboxes : this.rightCheckboxes;
        return group.every(ctrl => this.form.value[ctrl] === true);
    }

    isGroupIndeterminate(side: "left" | "right"): boolean {
        const group = side === "left" ? this.leftCheckboxes : this.rightCheckboxes;
        const someChecked = group.some(ctrl => !!this.form.value[ctrl]);
        const allChecked = group.every(ctrl => !!this.form.value[ctrl]);
        return someChecked && !allChecked;
    }

    // ─────────────────────────────────────────────────────────────────────────────
// 4) Add remove‐file methods for each step:
// ─────────────────────────────────────────────────────────────────────────────

    removeFileStep1(index: number): void {
        this.imageDataStep1.splice(index, 1);
        this.selectedFilesStep1.splice(index, 1);
        this.step1PhotosDisabled = !(this.selectedFilesStep1.length > 0 && this.imagesBusyCount === 0);
    }

    removeFileStep2(index: number): void {
        this.imageDataStep2.splice(index, 1);
        this.selectedFilesStep2.splice(index, 1);
        this.step2PhotosDisabled = !(this.selectedFilesStep2.length > 0 && this.imagesBusyCount === 0);
    }


// ─────────────────────────────────────────────────────────────────────────────
// 3) Add two new handlers that delegate to the helper:
// ─────────────────────────────────────────────────────────────────────────────

    async onFilesSelectedStep1(event: Event): Promise<void> {
        await this.handleFileSelection(event, this.selectedFilesStep1, this.imageDataStep1);
        this.step1PhotosDisabled = !(this.selectedFilesStep1.length > 0 && this.imagesBusyCount === 0);
    }

    async onFilesSelectedStep2(event: Event): Promise<void> {
        await this.handleFileSelection(event, this.selectedFilesStep2, this.imageDataStep2);
        this.step2PhotosDisabled = !(this.selectedFilesStep2.length > 0 && this.imagesBusyCount === 0);
    }


// ─────────────────────────────────────────────────────────────────────────────
// 2) Extract your existing onFilesSelected logic into a helper method:
// ─────────────────────────────────────────────────────────────────────────────

    private async handleFileSelection(
        event: Event,
        fileArray: FileObj[],
        previewArray: string[],
    ): Promise<void> {
        const input = event.target as HTMLInputElement;
        if (!input.files) return;

        for (const file of Array.from(input.files)) {
            // 1) mark busy
            this.imagesBusyCount++;
            this.updateLesikumButtonDisabledState();

            // 2) compress if needed
            let finalFile = file;
            try {
                if (this.IMAGE_COMPRESS) {
                    finalFile = await this.compressImageFile(file);
                }
            } catch {
                finalFile = file;
            } finally {
                this.imagesBusyCount--;
            }

            // 3) generate preview
            const dataUrl = await this.fileToDataURL(finalFile);
            previewArray.push(dataUrl);

            // 4) build FileObj
            const name = finalFile.name.replace(/\.\w+$/, "");
            const ext = finalFile.name.split(".").pop()!;
            fileArray.push({
                fileName: name,
                fileType: ext,
                file: finalFile,
                fileId: `${name}-${finalFile.lastModified}`,
                progress: 0,
                uploadStatus: UploadStatus.READY,
                formattedSize: formatBytes(finalFile.size, 2),
                fileSize: finalFile.size,
            });

            this.cd.detectChanges();
        }


    }

}
